import * as actions from "./actions"
import * as effects from "./effects"
import { state } from "./state"

export const config = {
  state,
  actions,
  effects,
}
